import React from 'react';
import { Theme, withStyles } from '@mui/material/styles';
import { Divider as MaterialDivider } from '@mui/material';

interface Props {}

const Divider = (props: Props) => {
  return (
    <MaterialDivider
      sx={{
        margin: '24px 0',
      }}
    />
  );
};

export default Divider;
